import { assets } from "../assets";
import { SplitBar } from "./SplitBar";

interface HeroStripProps {
  holderBps: number;
  lpTimeBps: number;
  burnBps: number;
}

export function HeroStrip({ holderBps, lpTimeBps, burnBps }: HeroStripProps) {
  return (
    <section className="glass p-6 lg:p-8 overflow-hidden">
      <div className="grid gap-6 lg:grid-cols-[1.4fr_1fr] items-center">
        <div className="relative z-10">
          <p className="text-xs font-mono tracking-[0.2em] text-wing">
            FENGNIAO REWARD DASHBOARD
          </p>
          <h1 className="text-3xl lg:text-4xl font-semibold mt-2 leading-tight">
            持币分 LP · LP 分 BNB
          </h1>
          <p className="text-sm text-ink-dim mt-2 max-w-md leading-relaxed">
            每笔买卖收 4% 税。一半奖励持币人 LP，四成奖励 LP 持有者 BNB，剩下回购销毁。
          </p>
          <div className="mt-6 max-w-md">
            <SplitBar
              holderBps={holderBps}
              lpTimeBps={lpTimeBps}
              burnBps={burnBps}
              compact
            />
            <div className="flex justify-between mt-2 text-[10px] font-mono uppercase tracking-wider text-ink-dim">
              <span className="text-wing/80">持币 LP</span>
              <span className="text-bnb/80">LP 时间 BNB</span>
              <span className="text-ember/80">回购销毁</span>
            </div>
          </div>
        </div>

        <div className="relative flex items-center justify-center">
          <span
            className="absolute inset-0 -z-10 blur-3xl bg-wing/20 opacity-40 rounded-full"
            aria-hidden
          />
          <img
            src={assets.fengniaoTokenHero}
            alt="蜂鸟代币"
            loading="eager"
            className="relative w-full max-w-[360px] mx-auto select-none"
            draggable={false}
          />
        </div>
      </div>
    </section>
  );
}
